
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InsuranceDocsClearDialogComponent } from '../../insurance-docs-clear-dialog/insurance-docs-clear-dialog.component';
import { SearchTermservice } from '../../../services/search/search-service.service'
import { InsuranceDoc } from '../../../model/insurance.model'
import { forEach } from '@angular/router/src/utils/collection';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule, MatPaginatorIntl } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatIconModule } from '@angular/material';
import { SortPipe } from '../../../../shared/sortPipe';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DownloadService } from '../../../services/download/download.service';
import { InsuranceService } from '../../../services/insurance/insurance.service';
import { Subject } from 'rxjs/Subject';
import { ParLicenseService } from '../../../services/par_license/par-license.service'
import { ParLicenseDialogueComponent } from '../par-license-dialogue/par-license-dialogue.component'
import * as moment from 'moment';
@Component({
  selector: 'app-par-licnese-documnet',
  templateUrl: './par-licnese-documnet.component.html',
  styleUrls: ['./par-licnese-documnet.component.css']
})
export class ParLicneseDocumnetComponent implements OnInit {
  clientDisable: any;
  clientHidden: any;
  public role: string;
  refresh = new Subject();
  doctype;
  agentName: string;
  agentId;
  agentDetails;
  pageSize = 10;
  insurancedocs = [];
  agentdoctype = [];
  dataSource: MatTableDataSource<UserData>;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'FileEdit'];
  message: string;
  sortedData;
  data: boolean = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: number;
  ispaginationFlag: boolean;
  noResults: string;
  licenseData: Array<any> = [];
  docCategory: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  uploadedFileName;
  placeholder = "Select a Document";
  constructor(public insuranceservice: InsuranceService,
    private downloadservice: DownloadService,
    private http: Http,
    private searchTermservice: SearchTermservice,
    private router: Router,
    public dialog: MatDialog,
    private parLicenseService: ParLicenseService) {

  }
  pageEvent: PageEvent;
  ngOnInit() {
    this.uploadedFileName = 'PAR License - PAR North America';
    this.parLicenseService.getLicenseDocTypes().subscribe(res => {
      this.agentdoctype = res.DocumentTypes;
      this.docCategory = this.agentdoctype[0].Category;
    }, error => {
      this.errorMessage = "Par License Document Types: " + error;
      this.errorEnable = true;
    })
    this.getDetails();
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }
  placeholderChange() {
    this.placeholder = "Document"
  }

  getDetails() {
    this.parLicenseService.getLicenseDocs().subscribe(res => {
      if (res.Licenses.length <= 0 || res.Licenses == undefined) {
        this.licenseData = [];
        this.licenseData = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No documents found";
        this.refresh.next();
      }
      else {
        this.licenseData = res.Licenses;
        this.message = '';
        this.data = true;
        this.dataSource = new MatTableDataSource(this.licenseData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.length = this.licenseData.length;
        if (this.length < 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, error => {
      this.errorMessage = "Par All License Documents: " + error;
      this.errorEnable = true;
    })
  }
  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }
  convertDateFormat(date) {
    if (date !== '' && date !== null && date !== undefined) {
      return moment(date).format('YYYY/MM/DD');
    }
    else {
      return ''
    }
  }

  clear(data, type?) {
    data.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(InsuranceDocsClearDialogComponent, {
      width: '400px',
      height: '200px',
      data: { 'data': data, 'type': 'parlicense' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doctype = null;
      this.getDetails();
    });
  }

  openDialog(name, type, id?): void {
    if (type === "update") {
      var Data = this.licenseData.find(doc => doc.LicenseId === id);
    } else {
      let code = null;
      code = this.agentdoctype.find(doc => doc.DocumentTypeName === name).DocumentTypeCode;
      var new_Data = {
        DocumentTypeName: name,
        DocumentTypeCode: code,
        DocumentCategory: this.docCategory
      };
    }

    let dialogRef = this.dialog.open(ParLicenseDialogueComponent, {
      width: '650px',
      height: '470px',
      data: { data: type === 'update' ? Data : new_Data, type: type, category: this.docCategory }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doctype = null;
      this.getDetails();
      this.placeholder = 'Select a Document'
    });
  }

  doctypechange(doc) {
    this.openDialog(doc, 'create');
  }

  fileEdit(docName, id, docDetails) {
    this.openDialog(docName, 'update', id);
    localStorage.setItem('old', JSON.stringify(docDetails));
  }
}

export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  FileEdit: any
}



// WEBPACK FOOTER //
// ./src/app/components/par-license/par-licnese-documnet/par-licnese-documnet.component.ts